var render = function render() {
        var _vm = this,
            _c = _vm._self._c;return _c('el-dropdown', { staticClass: "m-language-switch", class: {
                        'language-editting': _vm.isEdittingTopbar,
                        'dropdown-visible': _vm.visible
                }, attrs: { "trigger": "click" }, on: { "command": _vm.handleLanguageChange, "visible-change": _vm.visibleChange } }, [_c('div', { staticClass: "menu-wrapper" }, [_c('span', [_vm._v(_vm._s(_vm.languageCurrent))]), _vm._v(" "), _c('i', { staticClass: "el-icon-caret-bottom" })]), _vm._v(" "), _c('el-dropdown-menu', { staticClass: "user-dropdown", attrs: { "slot": "dropdown" }, slot: "dropdown" }, _vm._l(_vm.languageList, function (item) {
                return _c('el-dropdown-item', { key: item.value, attrs: { "command": item.value }, nativeOn: { "touchstart": function touchstart($event) {
                                        return function () {
                                                _vm.handleDropdownTouch(item.value);
                                        }.apply(null, arguments);
                                } } }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]);
        }), 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };